<template>
  <div>
    <div ref="blackBox" class="blackBox"></div>
    <transition mode="out-in" @appear="rvEnter" @leave="rvLeave" @enter="rvEnter">
      <slot></slot>
    </transition>
  </div>
</template>

<script>
export default {
  name: "BlackBoxLoader",
  methods: {
    rvEnter: function(el, done) {
      this.$anime({
        easing: "easeOutSine",
        delay: 500,
        duration: 1200,
        targets: this.$refs.blackBox,
        translateY: [0, "100%"],
        complete: done
      });
    },
    rvLeave: function(el, done) {
      this.$anime({
        easing: "easeInOutQuad",
        duration: 1000,
        targets: this.$refs.blackBox,
        translateY: ["-100%", 0],
        complete: done
      });
    }
  }
};
</script>

<style scoped lang="scss">
.blackBox {
  position: fixed;
  height: calc(100% + 1px);
  width: 100%;
  top: 0;
  left: 0;
  background: $lightPrimary;
  z-index: 10;
  border-top: solid 1px black;
  border-bottom: solid 1px black;
}
</style>
